import {Api} from '@/api/Api';
import {deserialize} from '@/api/Deserializer';
import {
  BiddingResponseSummarySchema,
  type BiddingResponseSummary,
} from '@/models/BiddingResponseSummary';

export default class BiddingResponseSummaryAPI extends Api {
  show(projectId: number, bidPackageId?: number): Promise<BiddingResponseSummary> {
    const contextPath = bidPackageId
      ? `/bid-packages/${bidPackageId}`
      : '';

    return this.get({
      url: `projects/${projectId}${contextPath}/bidding-response-summary`,
    })
      .then((res) => this.processResponse(res))
      .then((res) => deserialize<BiddingResponseSummary>(res, BiddingResponseSummarySchema) as BiddingResponseSummary);
  }
}
